

import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

import Period from '../../../../helpers/Period';
import Steps from '../../../../helpers/Steps';
// Material helpers
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';

// Material components
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Popover from '@material-ui/core/Popover';

import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import HelpIcon from '@material-ui/icons/Help';

import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

import Distribution from './Distribution'
import ResponseTimeGeneralDay from './ResponseTimeGeneralDay';
import ResponseWeekDay from './ResponseWeekDay';

// Component styles
import styles from './styles';

import moment from 'moment'
import 'moment/locale/es'
import { withTranslation } from 'react-i18next';
moment.locale('es')


class Percentage extends Component {
    constructor(props) {
        super(props);
        var year=String(props.year)
        var month=String(props.indexMonth+1)
        const begin=(moment(year+'-'+month+'-01')._d)
        const final= (moment(begin).endOf('month')._d)
        const periodical=true
        let statePeriod={startDate: begin,endDate: final,key: "selection"}
        if (props.globalPeriodValue === "custom") {
            statePeriod = props.globalStatePeriod
        }
        this.handlePeriodClick = this.handlePeriodClick.bind(this);
        this.handleNextStepClick = this.handleNextStepClick.bind(this);
        var scheduleType=0
        var schedules=JSON.parse(sessionStorage.getItem("horarios"))
        var scheduleName=(schedules.filter(i=>i.horario_id==props.schedule))[0]["nombre"]
        scheduleType=(schedules.filter(i=>i.horario_id==props.schedule))[0]["horario_id"]
        var idStep= props.steps[0]['id_paso']
        var pdf=false
        var isStep = false
       
        if(props.isStep===true){
            isStep = true
            idStep=parseInt(props.indexStep)
        }
        
        if(props.pdf===true){
            pdf=true
        }
        const nameStep = isStep?this.props.steps[idStep].nombre_paso:this.props.steps.find(i=>i.id_paso==idStep).nombre_paso

        this.state = {
            typeGraph: this.props.typeGraph,
            period: this.props.period,
            steps: this.props.steps,
            node: 0,
            isPdf:true,
            idStep: idStep,
            isStep : isStep,
            namePeriod: "Custom",
            objetive: this.props.match.params.objetivo_id,
            statePeriod:statePeriod,
            nameGraph: [' Distribucion Porcentual', ' TIEMPO DE RESPUESTA: POR DÍA DE LA SEMANA', ' Distribucion Disponibilidad Erores'],
            typePeriod: this.props.typePeriod,
            nameNodo:"Seleccione ISP",
            nameSelectStep: nameStep,
            periodical:periodical,
            periodEl: null,
            stepEl:null,
            schedule: scheduleType ? scheduleType : 0,
            scheduleName:scheduleName,
            detalleGraph:['  Corresponde a la disponibilidad Consolidada del objetivo durante el período y horario seleccionado', 
                        '  Corresponde a los tiempos de respuesta consolidados del objetivo durante el período seleccionado. \
                        El gráfico muestra, para cada paso del objetivo, una línea que representa los tiempos de respuesta \
                        promedio para cada día de la semana en contraste con los SLA Ok y SLA Error configurados',
                        '  Corresponde a los errores. Durante el período y horario seleccionado']
        };
    }

    handlePeriodClick(prevPeriod, prevTypeGraph, statePeriod, nextPeriod) {
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
         if (nextPeriod === 'custom') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "c",
                typePeriod: 3,
                namePeriod: `${t('text.range')}: ` + statePeriod.startDate.toISOString().substring(0, 10) + ` ${t('text.to2')} ` + statePeriod.endDate.toISOString().substring(0, 10),
                statePeriod: statePeriod,
                isStatePeriod: true,
                periodEl: null,
            });
        }
    }

    

    handleNextNodeClick = event => {
        const nameNodo = event.currentTarget.name
        const newNode = event.currentTarget.id
        if (this.state.node !== newNode) {
            this.setState({
                //typeGraph: prevTypeGraph,
                //period: prevPeriod,
                node: newNode,
                isLastEvent: false,
                extendEl: null,
                isRefresh: false,
                nameNodo: nameNodo,
            })
        }
    }
    handleNextStepClick = event => {
        const {steps}=this.state
        var index=0
        var nameStep = ''
        steps.map((i, ele)=>{
            if(i.id_paso===event.id_paso){
                index=ele
                nameStep=i.nombre_paso
            }
        })
        this.setState({
            idStep: index,
            stepEl: null,
            nameSelectStep:nameStep
        })
    }

    handleShowSteps=event=>{
        this.setState({
            stepEl: event.currentTarget
        });
    }
    handleShowStepsClose=()=>{
        this.setState({
            stepEl: null
        });
    }


    handleShowResponseTimeGraph = event => {
        this.setState({
            responseTimeGraphEl: event.currentTarget
        });
    };
    handleShowSettings = event => {
        this.setState({
            settingsEl: event.currentTarget
        });
    };
    handleShowIsInfo = event => {
        this.setState({
            isInfo: event.currentTarget
        });
    };

    handleCloseIsInfo = () => {
        this.setState({
            isInfo: null
        });
    };


    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget
        });
    };

    handleClosePeriod = () => {
        this.setState({
            periodEl: null
        });
    };
    handleCloseSettings = () => {
        this.setState({
            settingsEl: null
        });
    };


    componentDidUpdate(prevProps, prevState) {
    }

    render() {
        const { classes, className, location } = this.props;
        const { typeGraph, period, statePeriod, isStatePeriod,isStep, 
            namePeriod, node, isForNode, responseTimeGraphEl, periodEl, nameGraph, namePeriodPorlet, schedule, scheduleName,
            typePeriod, extendEl, settingsEl, isInfo, detalleGraph, nameSelectStep,periodical, steps, idStep, stepEl, isPdf} = this.state;

        const showSteps = Boolean(stepEl);
        const showSettingsEl = Boolean(settingsEl);
        const showIsInfo = Boolean(isInfo);
        const showPeriodEl = Boolean(periodEl);
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        var title = this.props.title + t(`${'percentage.periodical.name-graph'}.${typeGraph}`)

        if(typeGraph !== 1 && isStep === true){
            title = this.props.title + t(`${'percentage.periodical.name-graph'}.${typeGraph}`)+" "+nameSelectStep
        }
        return (

            <Portlet
                >
                <PortletHeader 
                >
                    <PortletLabel
                        /*  icon={<DevicesIcon />} */
                        variant="h1"
                        title={title}
                    />

                    <PortletToolbar>
                        <IconButton
                            onClick={this.handleShowSettings}
                        >
                            <SettingsOutlinedIcon />
                            
                        </IconButton>
                        <Popover
                            anchorEl={settingsEl}
                            onClose={this.handleCloseSettings}
                            open={showSettingsEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            >
                            <IconButton
                                onClick={this.handleShowIsInfo}
                                onClose={this.handleCloseIsInfo}
                            >
                                <div>
                                    <HelpIcon color="secondary"/><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>{t('percentage.periodical.button.information')}</Typography>
                                </div>
                            </IconButton>
                        </Popover>
                        <Popover
                            anchorEl={isInfo}
                            open={showIsInfo}
                            onClose={this.handleCloseIsInfo}
                            >
                            <PortletContent variant="h4" style={{fontSize:'16px', color:'#66788A'}}>{t(`${'percentage.periodical.chart-details'}.${typeGraph}`)}</PortletContent>
                        </Popover>
                    </PortletToolbar>
                </PortletHeader>
                <PortletContent>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        style={{textAlign:"center"}}
                    > 
                        <Typography   color="textSecondary" gutterBottom>
                            {t('text.from')} {statePeriod.startDate.toISOString().substring(0, 10)} {t('text.to')} {moment(statePeriod.endDate).format().substring(0, 10)}
                            <Typography   color="textSecondary" gutterBottom>
                               <b>{t('percentage.periodical.label.schedule')}</b> {scheduleName}
                            </Typography>
                        </Typography>
                    </Grid>
                    <Grid
                        container
                        spacing={10}
                    >
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            xl={12}>
                            
                            <Graph
                                typeGraph={typeGraph}
                                period={period}
                                step={isStep ? steps[idStep] : steps.find(i=>i.id_paso==idStep)}
                                node={node}
                                range={statePeriod}
                                schedule={schedule}
                                scheduleName={scheduleName}
                                isPdf={isPdf}
                            />                        
                            
                        </Grid>
                    </Grid>
                    
                </PortletContent>
                
                <PortletFooter >
                    <Grid container >
                        <Grid
                        item
                        xs={9}
                        sm={9}
                        md={9}
                        xl={9}>
                            <Button  style={{fontSize:'15px',float:'left', color:'#66788A'}} onClick={this.handleShowPeriod}>
                                Custom<ArrowDropDownIcon />
                            </Button>
                        </Grid>
                        {typeGraph !==1 && isStep === true?

                        <Grid
                        item
                        xs={3}
                        sm={3}
                        md={3}
                        xl={3}>
                            <Button
                                color="primary"
                                variant="text"
                                onClick={this.handleShowSteps}
                            >
                                {nameSelectStep}
                                <ArrowRightIcon />
                            </Button>
                        </Grid>
                        :
                        null
                        }
                    </Grid>
                    
                    <Popover
                        anchorEl={periodEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center'
                        }}
                        onClose={this.handleClosePeriod}
                        open={showPeriodEl}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center'
                        }}>
                        <Period onClick={this.handlePeriodClick} range={statePeriod} period={period} periodical={periodical} typeGraph={typeGraph} />
                    </Popover>
                    <Popover
                        anchorEl={stepEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center'
                        }}
                        onClose={this.handleShowStepsClose}
                        open={showSteps}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center'
                        }}>
                        { isStep === true?    
                        <Steps onClick={this.handleNextStepClick} steps={steps} step={isStep ? steps[idStep].nombre_paso : steps.find(i=>i.id_paso==idStep).nombre_paso}/>
                        :
                        null    
                        }
                    </Popover>
                </PortletFooter>
                
                
            </Portlet>
        )
    }
}

function Graph(props) {
    const typeGraph = props.typeGraph;
    if (typeGraph === 0) {    
        return (<Distribution data={props}/>)
    }
    if (typeGraph === 1) {
        return(
            <Grid container >
                <Grid
                    item
                    xs={6}
                    sm={6}
                    md={6}
                    xl={6}>
                        <ResponseTimeGeneralDay data={props}/>
                </Grid>
                <Grid
                    item
                    xs={6}
                    sm={6}
                    md={6}
                    xl={6}>
                        <ResponseWeekDay data={props}/>
                </Grid>
            </Grid>
        )
    }
    /*if (typeGraph === 2) {
        return <AvailabilityError />;
    }*/
}

export default
    compose(withRouter, withStyles(styles), withTranslation())(Percentage);